import React from "react"
import { Box, Typography } from "@mui/material"

export default function PageTitle() {
  return (
    <Box>
      <Typography variant="h4" fontWeight={900}>Dashboard</Typography>
    </Box>
  )
}